import '../../../../styles/globals.css'
import { Box, IconButton, Link, Typography } from '@mui/material'
import { useState } from 'react';
import { Grid } from '@mui/material';

import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';

export default function LoveSectionComponent(props) {

    const karmaContext = useKarmaPoolContext();

    const [loveCount, setLoveCount] = useState(props.note.loves);

    const [loved, setLoved] = useState(props.note.loved);

    function handleLoveClick(event) {
        event.preventDefault();

        if (loved) {
            setLoveCount(loveCount - 1);
            setLoved(false);
            karmaContext.noteManager.unloveNote(props.note.id);
        }
        else {
            setLoveCount(loveCount + 1);
            setLoved(true);
            karmaContext.noteManager.loveNote(props.note.id);
        }
    }

    if (props.note.isNewsletterNote) {
        return (
            <>
                <Grid item xs={1} sm={1} sx={{ textAlign: "right", paddingRight: "0.00rem" }}>


                </Grid>
                <Grid item xs={3} sm={3} sx={{ textAlign: "center", paddingRight: "0.0rem" }}>

                </Grid>
            </>
        );
    }

    return (
        <>
            <Grid item xs={1} sm={1} sx={{ textAlign: "right", paddingRight: "0.00rem" }}>
                <Box sx={{ paddingLeft: "0.85rem", marginBottom: "0.25rem" }}>
                    <IconButton onClick={handleLoveClick} >
                        { loved  ?
                        <FavoriteIcon sx={{ fontSize: "1.1rem", color: "rgba(255,255,255, 0.9)" }} /> :
                        <FavoriteBorderIcon sx={{ fontSize: "1.1rem", color: "rgba(255,255,255, 0.6)" }} /> }
                    </IconButton>
                </Box>

            </Grid>
            <Grid item xs={3} sm={3} sx={{ textAlign: "center", paddingRight: "0.0rem" }}>

                <Typography variant="body2" component="div" gutterBottom sx={{ fontSize: "0.825rem", marginLeft: "0.5225rem" }}>
                    {loveCount} love
                </Typography>

            </Grid>
        </>
    )
}
